import { convertJson, extractMeta } from "src/mixins"
import {
  Q_CITY_LIST,
  Q_FOOTER_DATA,
  Q_JOBS_LIST,
  Q_NEAREST_CONCESSION,
  Q_NEAREST_OUTLET,
  Q_OUTLET_DETAIL,
  Q_PAGE_BY_SLUG,
  Q_POSTS_BY_TYPE,
  Q_POSTS_MINIMUM,
  Q_POST_BY_SLUG,
  Q_POST_CATEGORIES_BY_SLUG,
  Q_POST_CATEGORIES_BY_TYPE,
  Q_POST_CATEGORY_BY_SLUG,
  Q_SEARCH_OUTLET_BY_CITY_ID,
} from "./query"

const API_URL =
  `${process.env.CMS_URL}/graphql` ||
  "https://cms-chiolite-ci01.antikode.dev/graphql"

export async function fetchAPI(query, { variables }) {
  try {
    const headers = { "Content-Type": "application/json" }

    const res = await fetch(API_URL, {
      method: "POST",
      headers,
      body: JSON.stringify({
        query,
        variables,
      }),
    })
    const json = await res.json()
    if (json.errors) {
      if (json?.errors?.length) {
        json.errors.map((item) => {
          throw new Error(`Failed to fetch API, reason ==> ${item.message}`)
        })
      }
    }
    return json.data
  } catch (error) {
    console.log("eeeeror", error)
    return { error }
  }
}

export async function getNearestoutlet(
  lat,
  lng,
  cinemaId,
  concessionId,
  fbConcessionId
) {
  const variables = {
    lat,
    lng,
    cinemaId,
    concessionId,
    fbConcessionId,
  }
  if (!cinemaId) delete variables.cinemaId
  if (!concessionId) delete variables.concessionId
  if (!fbConcessionId) delete variables.fbConcessionId
  const data = await fetchAPI(Q_NEAREST_OUTLET, {
    variables,
  })
  return data?.cityByNearest
}

export async function searchOutletByCityId(
  id,
  concessionId,
  cinemaId,
  { lat, lng }
) {
  const variables = { id, concessionId, cinemaId, lat, lng }
  Object.keys(variables).forEach((item) => {
    if (!variables[item]) delete variables[item]
  })
  const data = await fetchAPI(Q_SEARCH_OUTLET_BY_CITY_ID, {
    variables,
  })
  return data?.outlets?.data
}

export async function getAllCityList({ variables }) {
  const data = await fetchAPI(Q_CITY_LIST, { variables })
  return data?.cities
}

export async function getPageBySlug(slug) {
  const data = await fetchAPI(Q_PAGE_BY_SLUG, {
    variables: {
      slug,
    },
  })
  return data?.page
}
export async function getPostBySlug(slug) {
  const data = await fetchAPI(Q_POST_BY_SLUG, {
    variables: {
      slug,
    },
  })
  return data?.post
}
export async function getPostCategoriesByType(type) {
  const data = await fetchAPI(Q_POST_CATEGORIES_BY_TYPE, {
    variables: {
      type,
    },
  })
  return data?.postCategories
}
export async function getPostCategoryBySlug(slug) {
  const data = await fetchAPI(Q_POST_CATEGORY_BY_SLUG, {
    variables: {
      slug,
    },
  })
  return data?.postCategory
}
export async function getPostCategoriesBySlug(slug) {
  const data = await fetchAPI(Q_POST_CATEGORIES_BY_SLUG, {
    variables: {
      slug,
    },
  })
  return data?.postCategories
}
export async function getPostsByType({ first, type, orderBy, page, year }) {
  const data = await fetchAPI(Q_POSTS_BY_TYPE, {
    variables: {
      first,
      type,
      orderBy,
      page,
      year,
    },
  })
  return data?.posts
}
export async function getListJobs({ ...variables }) {
  const data = await fetchAPI(Q_JOBS_LIST, { variables })
  return data?.jobs
}

export async function getOutletDetail(slug) {
  const data = await fetchAPI(Q_OUTLET_DETAIL, { variables: { slug } })
  return { ...data.outlet, nowplaying: data.options }
}

export async function getProductServiceNavbar() {
  const data = await getPageBySlug("products")
  const cinema = await getPostCategoriesByType("CINEMA")
  const concessions = await getPostCategoriesByType("CONCESSION")
  const services = convertJson(extractMeta(data?.meta, "services")?.items)
  return { cinema, concessions, services }
}
export async function getNearestConcessionLocation({ ...variables }) {
  const data = await fetchAPI(Q_NEAREST_CONCESSION, { variables })
  return data?.concessionLocationByNearest
}

export async function getFooterData() {
  const data = await fetchAPI(Q_FOOTER_DATA, { variables: {} })
  const result = data?.options?.reduce(
    (obj, item) =>
      Object.assign(obj, {
        [item.option_name.split("general.")[1]]: item.option_value,
      }),
    {}
  )
  return result
}

export async function getListReports(categoryId) {
  const data = await fetchAPI(Q_POSTS_BY_TYPE, {
    variables: { type: "REPORT", categoryId, first: 100 },
  })
  return data?.posts?.data || data
}

export async function getListInvestorsGovernance(parentId) {
  const data = await fetchAPI(Q_POSTS_MINIMUM, {
    variables: { parentId, first: 100 },
  })
  return data?.posts?.data || data
}
